import { APPOINTMENT_PROVIDER_OPTIONS } from "./appointment-provider.utils";
import { CURRENT_USER_OPTIONS } from "./current-user.utils";
import {
  PATIENT_APPOINTMENTS_OPTIONS,
  PATIENT_CURRENT_APPOINTMENT_OPTIONS
} from "./patient-appointments.utils";
import { PATIENT_MISCELLANEOUS_OPTIONS } from "./patient-info/patient-miscellaneous.utils";
import { PATIENT_SELECTED_INVOICE_OPTIONS } from "./patient-selected-invoice.utils";

// Merge tags whose value can only ever be an <img> (a stored signature) or the
// interactive "Click to Add Signature" button — there is no text representation.
// In a text-only field (allowHtml=false) resolving one strips it to nothing and
// the insert silently cancels (SN-19323: fax cover-page notes), so these are
// removed from the picker there and refused at resolution time.
export const SIGNATURE_MERGE_TAG_VALUES = new Set<string>([
  CURRENT_USER_OPTIONS.SIGNATURE,
  APPOINTMENT_PROVIDER_OPTIONS.SIGNATURE,
  PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_STAFF_SIGNATURE,
  PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_DIRECT_SUPERVISING_PROVIDER_SIGNATURE,
  PATIENT_CURRENT_APPOINTMENT_OPTIONS.CURRENT_APPOINTMENT_SUPERVISING_PROVIDER_SIGNATURE,
  "Appointment.DirectSupervisor.Signature",
  "Appointment.Supervisor.Signature",
  PATIENT_APPOINTMENTS_OPTIONS.NEXT_APPOINTMENT_STAFF_SIGNATURE,
  PATIENT_APPOINTMENTS_OPTIONS.LAST_APPOINTMENT_STAFF_SIGNATURE,
  PATIENT_SELECTED_INVOICE_OPTIONS.PROVIDER_SIGNATURE,
  PATIENT_MISCELLANEOUS_OPTIONS.SIGNATURE,
  PATIENT_MISCELLANEOUS_OPTIONS.PREFERRED_PROVIDER_SIGNATURE,
  "Loaner.SignerSignature" // ENG-2497, in LOANER_SPEC
]);

// Accepts "Name", "{{Name}}", or "{{Name(options)}}".
export const isSignatureMergeTag = (
  tagName: string | undefined | null
): boolean => {
  if (!tagName) return false;

  const bareName = tagName
    .replace(/^\{\{/, "")
    .replace(/\}\}$/, "")
    .split("(")[0]
    .trim();

  return SIGNATURE_MERGE_TAG_VALUES.has(bareName);
};

export type MergeTagMenuEntry = {
  title: string;
  value?: string;
  menu?: MergeTagMenuEntry[];
};

// Drops signature entries, then drops any submenu left empty by that filtering.
export const stripSignatureMergeTags = <T extends MergeTagMenuEntry>(
  group: T
): T => {
  if (!group.menu) return group;

  const menu = group.menu
    .filter(
      (entry) => !entry.value || !SIGNATURE_MERGE_TAG_VALUES.has(entry.value)
    )
    .map((entry) => stripSignatureMergeTags(entry))
    .filter((entry) => entry.value || entry.menu?.length);

  return { ...group, menu };
};
